"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatContext, useAIChatMessageContext } from "../contexts";
import { FiThumbsDown, FiThumbsUp } from "react-icons/fi";
import { Tooltip } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
import { AIFeedbackType } from "@/types/enums";
interface AIChatMessageFeedbackButtonsProps {
  className?: string;
}
export function AIChatMessageFeedbackButtons(t0) {
  const $ = _c(34);
  const {
    className
  } = t0;
  const {
    actions
  } = useAIChatContext();
  const {
    message,
    index
  } = useAIChatMessageContext();
  if (!actions.handleFeedback) {
    throw new Error("AIChat.Message.FeedbackButtons requires actions.handleFeedback in AIChatContext. Either provide handleFeedback in your AIChat.Provider actions, or don't compose FeedbackButtons.");
  }
  if (message.role !== "assistant") {
    return null;
  }
  const {
    handleFeedback
  } = actions;
  let t1;
  if ($[0] !== className) {
    t1 = cx("flex items-center gap-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = message.feedbackType === AIFeedbackType.POSITIVE ? "Thanks!" : "Helpful";
  let t3;
  if ($[2] !== handleFeedback || $[3] !== index || $[4] !== message.id) {
    t3 = () => handleFeedback(message.id, AIFeedbackType.POSITIVE, index);
    $[2] = handleFeedback;
    $[3] = index;
    $[4] = message.id;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = message.pendingFeedback;
  const t5 = message.feedbackType === AIFeedbackType.POSITIVE ? "text-status-success-text hover:bg-status-success-bg" : "text-foreground-muted hover:bg-hover hover:text-status-success-text";
  let t6;
  if ($[6] !== t5) {
    t6 = cx("rounded p-0.5 transition-colors", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FiThumbsUp className="h-3 w-3" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== message.pendingFeedback || $[10] !== t3 || $[11] !== t6) {
    t8 = <button type="button" aria-label="Helpful" onClick={t3} disabled={t4} className={t6}>{t7}</button>;
    $[9] = message.pendingFeedback;
    $[10] = t3;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t2 || $[14] !== t8) {
    t9 = <Tooltip content={t2} triggerAsChild={true}>{t8}</Tooltip>;
    $[13] = t2;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = message.feedbackType === AIFeedbackType.NEGATIVE ? "Thanks!" : "Not helpful";
  let t11;
  if ($[16] !== handleFeedback || $[17] !== index || $[18] !== message.id) {
    t11 = () => handleFeedback(message.id, AIFeedbackType.NEGATIVE, index);
    $[16] = handleFeedback;
    $[17] = index;
    $[18] = message.id;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = message.pendingFeedback;
  const t13 = message.feedbackType === AIFeedbackType.NEGATIVE ? "text-status-error-text hover:bg-status-error-bg" : "text-foreground-muted hover:bg-hover hover:text-status-error-text";
  let t14;
  if ($[20] !== t13) {
    t14 = cx("rounded p-0.5 transition-colors", t13);
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FiThumbsDown className="h-3 w-3" />;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== message.pendingFeedback || $[24] !== t11 || $[25] !== t14) {
    t16 = <button type="button" aria-label="Not helpful" onClick={t11} disabled={t12} className={t14}>{t15}</button>;
    $[23] = message.pendingFeedback;
    $[24] = t11;
    $[25] = t14;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t10 || $[28] !== t16) {
    t17 = <Tooltip content={t10} triggerAsChild={true}>{t16}</Tooltip>;
    $[27] = t10;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t1 || $[31] !== t17 || $[32] !== t9) {
    t18 = <div className={t1}>{t9}{t17}</div>;
    $[30] = t1;
    $[31] = t17;
    $[32] = t9;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
}